import {Injectable} from '@angular/core';
import {CoreService} from '../../../core/service';
import {doc, DocumentData, Firestore, setDoc} from '@angular/fire/firestore';
import {from, Observable} from 'rxjs';

/**
 * Service for managing user and store settings.
 * Extends CoreService to provide Firestore database operations for settings data.
 * Handles user preferences, application settings, store configurations, and feature-specific settings.
 */
@Injectable({
  providedIn: 'root',
})
export class SettingsService extends CoreService {

  /**
   * Initialize settings service with Firestore instance
   * @param {Firestore} firestore - Angular Firebase Firestore instance for database operations
   */
  constructor(firestore: Firestore) {
    super(firestore);
  }

  /**
   * Overwrites a settings document so removed index keys (e.g. price bands) are not left behind.
   */
  setDocumentOverwriteAsObservable<DataType>(path: string, data: DataType): Observable<void> {
    const docRef = doc(this.firestore, path);
    return from(setDoc(docRef, data as DocumentData));
  }

}
